import { render, staticRenderFns } from "./GooglePlacesAutocomplete.vue?vue&type=template&id=197f9061&scoped=true"
import script from "./GooglePlacesAutocomplete.vue?vue&type=script&lang=js"
export * from "./GooglePlacesAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./GooglePlacesAutocomplete.vue?vue&type=style&index=0&id=197f9061&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197f9061",
  null
  
)

export default component.exports